// extracted by mini-css-extract-plugin
export default {"ParentIssueTokenContainer":"parent-issue-token-module__ParentIssueTokenContainer--ecTQf","ParentIssueTokenMain":"parent-issue-token-module__ParentIssueTokenMain--pbTy7"};